import {Abogado} from "./abogado";
import {Phone} from "../../profile/domain/phone";
import {CurriculumVitae} from "../../profile/domain/curriculumVitae";

export class AbogadoDetail extends Abogado {

    phones: Phone[];
    cv: CurriculumVitae;

    constructor(value: Object = {}) {
        super(value);
        this.phones = this.phones ? this.phones.map(phone => new Phone(phone)) : [];
        this.cv = this.cv ? new CurriculumVitae(this.cv) : null;
    }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/domain/abogado-detail.ts